import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import reduction_inside from "./reduction_inside.vue";

window.tenderProtocolReduction = createApp({
    name : "ReductionInside",
    id : "ReductionInside",
    components : {
        reduction_inside : reduction_inside,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);

tenderProtocolReduction.mount('#reductionInside');